import { merge } from 'lodash';
import REST from '../rest';

const ENDPOINT = 'api/v1/campaigns';
const DEFAULT_PAGE_SIZE = 1000;

const queryParams = (params) => (
  merge({}, params, { page: { size: DEFAULT_PAGE_SIZE } })
);

export const get = (id) => REST.get(ENDPOINT, id);
export const load = (params) => REST.get(ENDPOINT, '', queryParams(params));
